import { autoinject, } from "aurelia-framework";
import { LanguageService } from '../../../services/language';


@autoinject
export class LangSelectCustomElement {

	selectorEl: HTMLInputElement;

	constructor(private _langService: LanguageService) { }

	attached() {
		this.selectorEl.value = this._langService.CurrentLang;
	}

	onLangChanged(ev: Event) {
		const selectEl = ev.target as HTMLSelectElement;
		this._langService.CurrentLang = selectEl.value;
	}
}
